import { render, staticRenderFns } from "./CryptoPayment.vue?vue&type=template&id=446380cb"
import script from "./CryptoPayment.vue?vue&type=script&lang=js"
export * from "./CryptoPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports